module.exports = __webpack_public_path__ + "img/55.0c2963f0.png";